
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 2.254a4.502 4.502 0 00-4.388 3.5H3.5a1 1 0 100 2h1.096l1.298 12.822c.073.73.135 1.335.224 1.827.092.513.227.98.488 1.414a4 4 0 001.72 1.554c.502.237 1.032.32 1.614.355.17.01.35.017.539.02a1 1 0 00.042-1.999c-.172-.004-.324-.01-.46-.017-.48-.03-.715-.09-.881-.167a2 2 0 01-.86-.778c-.086-.142-.163-.344-.234-.738-.074-.406-.128-.932-.206-1.71L6.606 7.754h14.788l-.288 4.15a1 1 0 101.99.202l.308-4.352H24.5a1 1 0 100-2h-6.111A4.502 4.502 0 0014 2.254zm-2.292 3.5a2.5 2.5 0 014.584 0h-4.584z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.258 16.011a1 1 0 000 1.414l2.828 2.829-2.828 2.828a1 1 0 001.414 1.414l2.828-2.828 2.828 2.828a1 1 0 001.415-1.414l-2.829-2.828 2.829-2.829a1 1 0 00-1.415-1.414L18.5 18.84l-2.828-2.829a1 1 0 00-1.415 0z","fill":"currentColor"}})])
          )
        }
      }
    